
import React from "react"
import Index from "./Index"
import { contentLayout, modules } from "../config/pages"
import { useUser } from "../contexts/UserContext"
import Forbidden from "./Forbidden"

function ViewMovementDetail (){
  const {user} = useUser()
  let view = contentLayout[modules.MovementDetail]
  
  // Basic permission check - reuse MovementList permission or add specific one if needed.
  // For now assuming if you can view list, you can view detail, or check specific perms.
  // "views" usually contains module names.
  
  if(user.permissions.views.length && !user.permissions.views.join().includes(modules.MovementList.toLowerCase())){
     // Using MovementList permission as proxy for now.
    view = Forbidden
  }
  
  return(
  <Index content={view} module={modules.MovementDetail}></Index>
 )
}

export default ViewMovementDetail
